import { IClassname } from '@/lib/shared/model/classname';

export const GuestSVG = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 11C11 12.3261 11.5268 13.5979 12.4645 14.5355C13.4021 15.4732 14.6739 16 16 16C17.3261 16 18.5979 15.4732 19.5355 14.5355C20.4732 13.5979 21 12.3261 21 11C21 9.67392 20.4732 8.40215 19.5355 7.46447C18.5979 6.52678 17.3261 6 16 6C14.6739 6 13.4021 6.52678 12.4645 7.46447C11.5268 8.40215 11 9.67392 11 11Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0158 25H8C7.99995 23.7432 8.3765 22.5095 9.09013 21.4285C9.80376 20.3476 10.8281 19.4592 12.0557 18.8567C13.2832 18.2542 14.6687 17.9598 16.0665 18.0044C17.4644 18.049 18.8231 18.431 20 19.1102"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9842 25H24C24.0001 23.7432 23.6235 22.5095 22.9099 21.4285C22.1962 20.3476 21.1719 19.4592 19.9443 18.8567C18.7168 18.2542 17.3313 17.9598 15.9335 18.0044C14.5356 18.049 13.1769 18.431 12 19.1102"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
